import { defineMessages, IntlShape } from "react-intl";

import ActivityStatusOption from "@mapmycustomers/shared/enum/activity/ActivityStatusOption";

import { getDisplayName } from "./getDisplayName";

const messages = defineMessages({
  [ActivityStatusOption.ALL]: {
    id: "activityStatusOption.all",
    defaultMessage: "Any Status",
    description: "Activity Status Option all",
  },
  [ActivityStatusOption.COMPLETED]: {
    id: "activityStatusOption.completed",
    defaultMessage: "Done",
    description: "Activity Status Option Done",
  },
  [ActivityStatusOption.INCOMPLETE]: {
    id: "activityStatusOption.incomplete",
    defaultMessage: "Not yet done",
    description: "Activity Status Option Not yet done",
  },
  [ActivityStatusOption.NOT_SCHEDULED]: {
    id: "activityStatusOption.notScheduled",
    defaultMessage: "Not Scheduled",
    description: "Activity Status Option Not Scheduled",
  },
  [ActivityStatusOption.OVERDUE]: {
    id: "activityStatusOption.overdue",
    defaultMessage: "Overdue",
    description: "Activity Status Option Overdue",
  },
  [ActivityStatusOption.UPCOMING]: {
    id: "activityStatusOption.upcoming",
    defaultMessage: "Upcoming",
    description: "Activity Status Option Upcoming",
  },
});

const getActivityStatusOptionDisplayName = (
  intl: IntlShape,
  activityStatus: ActivityStatusOption
) => getDisplayName(intl, messages, activityStatus, "ActivityStatusOption");

export default getActivityStatusOptionDisplayName;
